import React, { useState } from "react";
import VideoPlayerModal from "./VideoPlayerModal";

const WatchDemoVideoButton = ({ 
  videoUrl, 
  title = "Demo Video",
  className = "",
  buttonText = "Watch Demo Video"
}) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  if (!videoUrl) return null;

  return (
    <>
      <button
        onClick={() => setIsVideoModalOpen(true)}
        className={`flex items-center space-x-2 px-3 py-[10px] bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-medium transition-colors duration-200 ${className}`}
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>{buttonText}</span>
      </button>

      <VideoPlayerModal
        isOpen={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        videoUrl={videoUrl}
        title={title}
      />
    </>
  );
};

export default WatchDemoVideoButton;

